import type { ReactNode } from "react";

type Props = {
  label: string;
  htmlFor?: string;
  children: ReactNode;
  className?: string;
  compact?: boolean;
};

const FormField = ({
  label,
  htmlFor,
  children,
  className,
  compact = false,
}: Props) => {
  return (
    <div className={className}>
      <label
        htmlFor={htmlFor}
        className={
          compact
            ? "mb-1 block text-xs font-medium text-secondary-foreground"
            : "mb-2 block text-sm font-medium text-foreground"
        }
      >
        {label}
      </label>
      {children}
    </div>
  );
};

export default FormField;
